import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { AddressSelectFormikField } from '../../../../Address'
import {
  BUILDING_FORM_ADDRESS_FIELD_MAX_LENGTH,
  BUILDING_FORM_FIELD_NAME_ADDRESS,
} from '../../BuildingForm.constants'

function AddressField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <AddressSelectFormikField
      {...props}
      withEntityCreationFromSearchValue
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Building.TitlePlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Building.TitleLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      maxLength={BUILDING_FORM_ADDRESS_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_ADDRESS}
    />
  )
}

export default AddressField
